export enum GroupLinkedDeviceActionTypes {
    SET_GROUPLINKEDDEVICES = "SET_GROUPLINKEDDEVICES",
    CLEAR_GROUPLINKEDDEVICES = "CLEAR_GROUPLINKEDDEVICES"
}